import { Traveler } from '@flysas-tech/book-value-stream-models';
import { Object, Omit, Static } from '@sinclair/typebox';

export type SavedTraveler = Static<typeof SavedTraveler>;
export const SavedTraveler = Object({
  ...Omit(Traveler, ['type', 'isPrimary']).properties,
});

export type TemporaryTraveler = Omit<Traveler, 'id' | 'isPrimary'>;
